/* eslint-disable react/prop-types */
import { useParams } from "react-router-dom"
import { useLazyQuery } from "@apollo/client"
import { compose, withProps } from "recompose"
import gql from "graphql-tag"
import ExcludedLocationsModal from "."

const excludedLocationsLazyQuery = withProps((props) => {
  const { facilityId } = useParams()
  const excludedLocationsQuery = gql`
    query ContactTracingExcludedLocations($facilityId: ID!) {
      facility(id: $facilityId) {
        id
        listItems: locations(contactTracing: false) {
          id
          name
          unit {
            id
            name
          }
        }
      }
    }
  `
  const [
    loadExcludedLocations,
    { loading, error, called, data },
  ] = useLazyQuery(excludedLocationsQuery)

  const onLoad = () => {
    loadExcludedLocations({
      variables: {
        facilityId,
      },
    })
  }

  if (error) throw error
  if (!called || loading) return { onLoad, loading, facilityId }

  const locations = data.facility.listItems.map((location) => ({
    locationName: location.name,
    unitName: location.unit.name,
  }))
  const excludedLocations = []
  locations.forEach((el) => {
    const idx = excludedLocations.findIndex(
      (item) => item.unitName === el.unitName
    )
    if (idx !== -1) {
      const obj = excludedLocations[idx]
      obj.excludedLocations.push(el.locationName)
      excludedLocations.splice(idx, 1, obj)
    } else {
      excludedLocations.push({
        unitName: el.unitName,
        excludedLocations: [el.locationName],
      })
    }
  })

  return {
    onLoad,
    facilityId,
    excludedLocations: excludedLocations,
  }
})

const ExcludedLocationsModalEnhanced = compose(excludedLocationsLazyQuery)(
  ExcludedLocationsModal
)

export default ExcludedLocationsModalEnhanced
